var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 71,
    viewBox: "0 0 79 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0972 31.6413L60.3944 9.26087L79 19.808L76.785 55.1793L38.0972 71V31.6413Z",
    fill: "#5DA3E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8206 0L60.3944 9.26087L38.0972 31.6413L0 19.1649L20.8206 0Z",
    fill: "#A1D0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.1649L38.0972 31.6413V71L2.21495 54.4076L0 19.1649Z",
    fill: "#558CC4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7028 39.2301L69.4019 34.471L68.5159 58.5236L55.9645 63.6685L56.7028 39.2301Z",
    fill: "#074079"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.73b2961573b9e599bffea4d264d75a22.svg";
export { ForwardRef as ReactComponent };